exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-listItem-NsplpkVQ {\n  display: inline;\n}\n\n.styles-container-TTqsS8OV {\n  padding: 0px 40px 80px 40px;\n}\n", ""]);

// exports
exports.locals = {
	"listItem": "styles-listItem-NsplpkVQ",
	"container": "styles-container-TTqsS8OV"
};